<template>
  <div class="page page-social">
    <nav-bar />
    <div class="page-wrapper">
      <div class="social">
        <div class="social__main">
          <div class="page-nav">
            <h2 class="page-nav__title">Шаг 3</h2>
            <a class="page-nav__link" @click="checkAndBack">Компоненты </a>
            <p class="page-nav__current">/ Социальные сети</p>
          </div>
          <h1 class="social__title">Социальные сети</h1>
          <div class="social__form">
            <div
              v-for="(item, index) in items"
              :key="index + item.link"
              class="social__item"
            >
              <CInput
                placeholder="Ссылка на страницу"
                :label="item.name"
                v-model="item.link"
                type="latin"
                :required="true"
                :initVal="item.link"
                tooltip="Введите логин вашей социальной сети."
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
                @valid="item.valid = true"
                @invalid="item.valid = false"
                :removable="true"
                @removeit="remove(index)"
              />
            </div>
            <CSelect
              v-model="select"
              :options="socialNetworks"
              selected="false"
              blank="Добавить"
              class="social__select"
              @change="addNewItem"
              @click="showTooltip"
              tooltip="Чтобы добавить ещё одну социальную сеть, нажмите здесь."
              :tooltip_action="show_tooltip"
              tooltip_position="right"
            />
          </div>
        </div>
        <div class="social__buttons">
          <button class="social__back" @click="checkAndBack">
            <svg-icon type="back" />
            Назад
          </button>
          <button class="social__send" @click="save">
            Сохранить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import CInput from "../../components/forms/CInput";
import CSelect from "../../components/forms/CSelect";
import CTooltip from "../../components/forms/CTooltip";

export default {
  name: "Social",
  components: { CSelect, CInput, CTooltip },
  data() {
    return {
      show_tooltip: true,
      socialNetworks: [
        {
          label: "Вконтакте",
          image: require("@/assets/img/socialModal/vk.svg"),
          value: "Вконтакте"
        },
        {
          label: "Facebook",
          image: require("@/assets/img/socialModal/fb.svg"),
          value: "Facebook"
        },
        {
          label: "Одноклассники",
          image: require("@/assets/img/socialModal/ok.svg"),
          value: "Одноклассники"
        },
        {
          label: "Instagram",
          image: require("@/assets/img/socialModal/instagram.svg"),
          value: "Instagram"
        },
        {
          label: "Twitter",
          image: require("@/assets/img/socialModal/twitter.svg"),
          value: "Twitter"
        },
        {
          label: "YouTube",
          image: require("@/assets/img/socialModal/youtube.svg"),
          value: "YouTube"
        }
      ],
      items: [],
      items_template: [
        {
          link: "",
          name: "Вконтакте",
          prefix: "vk.com/",
          type: "vk"
        },
        {
          link: "",
          name: "Instagram",
          prefix: "instagram.com/",
          type: "instagram"
        },
        {
          link: "",
          name: "Одноклассники",
          prefix: "ok.ru/",
          type: "ok"
        },
        {
          link: "",
          name: "Facebook",
          prefix: "fb.com/",
          type: "fb"
        },
        {
          link: "",
          name: "YouTube",
          prefix: "youtube.com/",
          type: "youtube"
        },
        {
          link: "",
          name: "Twitter",
          prefix: "twitter.com/",
          type: "twitter"
        }
      ],
      content: {},
      select: {
        label: "",
        image: "",
        value: ""
      }
    };
  },
  computed: {
    ...mapGetters(["getComponentByName"])
  },
  methods: {
    showTooltip() {
      this.show_tooltip = false;
    },
    checkAndBack() {
      if (!this.items.length) {
        this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("SocialLinks").id,
          content: Object.assign({}, { items: this.items }),
          enabled: false
        });
      }
      this.$router.go(-1);
      this.GAEvent("step_3-social-network_back");
    },
    fillModalFromState() {
      const component = this.getComponentByName("SocialLinks");
      if (component && component.content && component.content.items) {
        this.content = Object.assign({}, component.content);
        this.items = this.content.items.map(item => {
          if (item.checked) {
            item.valid = item.checked;
            delete item.checked;
          }
          return item;
        });
      }
    },
    addNewItem() {
      const itemTemplate = Object.assign(
        {},
        this.items_template.find(i => i.name === this.select)
      );
      itemTemplate.link = "";
      itemTemplate.valid = true;
      this.items.push(itemTemplate);
    },
    remove(index) {
      Vue.delete(this.items, index);
    },
    save() {
      let newContent = this.items.filter(i => !!i.link && i.valid);
      let invalidContent = this.items.filter(i => !i.link || !i.valid);
      newContent = newContent.map(item => {
        item.link = item.link
          .replace(/^https?:\/\//, "")
          .replace(/^www\./, "")
          .replace("@", "")
          .replace(new RegExp(`^${item.prefix}`), "");
        if (item.type === "fb") {
          item.link = item.link.replace(/^facebook\.com\//, "");
        }
        return item;
      });
      if (invalidContent.length) {
        if (
          !confirm(
            "Неправильно заполненный контент не будет сохранен! Продолжить?"
          )
        )
          return;
      }
      this.$store.dispatch("syncComponent", {
        id: this.getComponentByName("SocialLinks").id,
        content: { items: newContent },
        enabled: newContent.length > 0
      });
      this.items = newContent;
      this.GAEvent(
        "step_3-social-network",
        "chosen-social",
        newContent.map(c => c.type)
      );
    }
  },
  mounted() {
    this.fillModalFromState();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
  }
}

.page-nav {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 5px;
  &__title {
    font-weight: bold;
    font-size: 23px;
    line-height: 21px;
    color: #cccccc;
    margin: 0 15px 0 0;
  }
  &__link {
    font-size: 16px;
    line-height: 19px;
    color: #3a5eec;
    cursor: pointer;
    margin: 0 5px 0 0;
  }
  &__current {
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    margin: 0;
  }
}
.social {
  width: 100%;
  max-width: 1200px;
  background: #f4f4f4;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
  }

  * {
    font-family: "Inter", sans-serif;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    text-align: left;
    margin: 0 0 10px;
    padding: 0;
    @media #{$mobile} {
      font-size: 34px;
      margin: 0 0 30px;
    }
  }

  &__main {
    padding: 60px 70px;
    @media #{$tablet} {
      padding: 30px;
    }
    @media #{$mobile} {
      padding: 30px 15px;
    }
  }

  &__form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 90px;
    @media #{$mobile} {
      flex-direction: column;
    }

    &__column {
      display: flex;
      flex-direction: column;
      flex-basis: 290px;
      @media #{$mobile} {
        flex-basis: 100%;
      }

      &:not(:last-child) {
        margin-right: 30px;
        @media #{$mobile} {
          margin-right: 0;
        }
      }
    }
  }

  &__input {
    display: flex;
    flex-direction: column;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    input,
    textarea {
      border: 1px solid #cccccc;
      outline: none;
      border-radius: 5px;
      padding: 10px 15px;
      font-size: 16px;
      background: transparent;
      resize: none;

      &:focus {
        border-color: #3479cc;
      }
    }

    &.valid input,
    &.valid textarea {
      border-color: #3479cc;
    }

    &.invalid input,
    &.invalid textarea {
      border-color: #3479cc;
    }

    textarea {
      height: 90px;
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
    }
  }

  &__file_wrapper {
    background: #ffffff;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    @media #{$mobile} {
      background: #f2f2f2;
    }

    & *:first-child {
      margin-right: 20px;
    }

    span {
      font-size: 15px;
      max-width: 180px;
    }

    input {
      display: none;
    }
  }

  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__back {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 30px;
    }

    span {
      margin-right: 10px;
    }
  }

  &__send {
    border-radius: 5px;
    border: none;
    background: #3a5eec;
    color: #ffffff;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    padding: 15px 40px;
    @media #{$mobile} {
      margin-bottom: 30px;
    }
  }
  &__item {
    width: 290px;
    margin-right: 30px;
    margin-top: 22px;
  }
  &__select {
    width: 290px;
    margin-top: 25px;
    margin-bottom: 0;
  }
  .select__options {
    width: 290px;
    left: -1px;
  }
}
</style>
